import { useState } from 'react';
import { ContainerSpin } from './styles';
import { Button, Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import Table, { ColumnType } from 'antd/lib/table';
import CardMobile from './CardMobile';
import TextTable from '../../../../../../components/TextTable';
import TitlePage from '../../../../../../components/TitlePage';
import TitleTable from '../../../../../../components/TitleTable';
import Spin from '../../../../../../components/Spin';
import { ItensNota } from '../../services/coletaNoCdServices';
import type { INotas } from '../../services/coletaNoCdServices';
import mask from '../../../../../../utils/mask';
import { useWindowSize } from '../../../../../../hook/useWindowSize';
import Swal from 'sweetalert2';

const ModalItensNota: React.FC<{ nuNota: number; numNF: number }> = ({ nuNota, numNF }) => {
  const { width }: any = useWindowSize();
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [listaItensNota, setListaItensNota] = useState<INotas[] | undefined>();

  const showModal = () => {
    try {
      ItensNota.getItensNota(nuNota).then((res) => {
        setListaItensNota(res.data.itensNota);
      });
    } catch (error: any) {
      if (error.response.data.Erro) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response.data.Erro,
        });
      }
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Erro ao carregar os dados!',
      });
    }

    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setListaItensNota(undefined);
  };

  let columnsModal: ColumnType<INotas>[] = [
    {
      title: <TitleTable>Código produto</TitleTable>,
      dataIndex: 'codProduto',
      key: 'codProduto',
      align: 'left',
      width: 150,
      render: (text) => {
        return text ? <TextTable>{text}</TextTable> : <TextTable>Não informado</TextTable>;
      },
    },
    {
      title: <TitleTable>Referência</TitleTable>,
      dataIndex: 'referencia',
      key: 'referencia',
      align: 'left',
      width: 150,
      render: (text) => {
        return text ? <TextTable>{text}</TextTable> : <TextTable>Não informado</TextTable>;
      },
    },
    {
      title: <TitleTable>Produto</TitleTable>,
      dataIndex: 'descricaoProduto',
      key: 'descricaoProduto',
      align: 'left',
      width: 250,
      render: (text) => {
        return text ? (
          <TextTable>{mask('camelCase', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: <TitleTable>Lote</TitleTable>,
      dataIndex: 'controle',
      key: 'controle',
      align: 'left',
      width: 150,
      render: (text) => {
        return text ? <TextTable>{text}</TextTable> : <TextTable>Não informado</TextTable>;
      },
    },
    {
      title: <TitleTable>Quantidade</TitleTable>,
      dataIndex: 'quantidade',
      key: 'quantidade',
      align: 'right',
      width: 150,
      render: (text) => {
        return text ? (
          <TextTable>{mask('quantidade', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: <TitleTable>Unidade</TitleTable>,
      dataIndex: 'volume',
      key: 'volume',
      align: 'left',
      width: 100,
      render: (text) => {
        return text ? (
          <TextTable>{mask('camelCase', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: <TitleTable>Peso bruto</TitleTable>,
      dataIndex: 'pesoBruto',
      key: 'pesoBruto',
      align: 'right',
      width: 150,
      render: (text) => {
        return text ? (
          <TextTable>{mask('peso', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: <TitleTable>Valor total</TitleTable>,
      dataIndex: 'valorTotal',
      key: 'valorTotal',
      align: 'left',
      width: 180,
      render: (text: number = 0) => {
        return text ? (
          <TextTable>{mask('currency', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        centered
        title={<TitlePage> Lista de produtos NF {numNF} </TitlePage>}
        visible={isModalVisible}
        onCancel={handleCancel}
        onOk={handleCancel}
        maskClosable={true}
        closable={true}
        destroyOnClose={true}
        closeIcon={<CloseOutlined />}
        keyboard={true}
        width={1300}
        footer={
          <Button onClick={handleCancel} type="primary">
            Fechar
          </Button>
        }
      >
        {width > 768 && listaItensNota ? (
          listaItensNota.length !== 0 ? (
            <Table
              style={{ fontSize: 10, display: 'inline', width: '100%' }}
              scroll={{ x: 1200 }}
              columns={columnsModal}
              size={'large'}
              pagination={{
                defaultPageSize: 3,
                defaultCurrent: 1,
                showSizeChanger: true,
                pageSizeOptions: ['3', '5', '10', '20', '50'],
                locale: { items_per_page: '/ página' },
              }}
              dataSource={listaItensNota}
              className="table"
              rowKey={'nuNota'}
            />
          ) : (
            <h3>Não há itens para essa nota</h3>
          )
        ) : (
          <ContainerSpin>
            <Spin />
          </ContainerSpin>
        )}
        {width <= 768 && <CardMobile />}
      </Modal>

      <button
        style={{
          padding: 0,
          height: 'auto',
          border: 'none',
          background: 'none',
          color: '#00B1F1',
          cursor: 'pointer',
          fontWeight: 700,
        }}
        onClick={showModal}
      >
        {numNF}
      </button>
    </>
  );
};

export default ModalItensNota;
